













import { defineComponent } from '@nuxtjs/composition-api'
import { useConfig } from '~/composables';

export default defineComponent({
    setup() {
        const { config } = useConfig();
        return {
            storeCode: config.value.store_code
        }
        
    },
})
